<h1 mat-dialog-title>
	{{ title }}
</h1>
<div mat-dialog-content>
	<p>{{ text | translate }}</p>
</div>
<div mat-dialog-actions style="justify-content: flex-end; display: flex;">
  <button mat-raised-button color="warn" (click)="onCancelClick()">
    {{ cancelBtnText | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ okBtnText | translate }}
  </button>
</div>
